var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60439 2.59094V10.7678C6.60439 10.948 6.41296 11.0641 6.25093 10.9854C4.21548 9.99632 2.95542 9.91305 1.03369 10.9543C0.869881 11.0431 0.666504 10.9272 0.666504 10.7409V2.58666C0.666504 2.5036 0.710394 2.42553 0.781251 2.3822C3.12677 0.947875 4.39443 1.17236 6.4846 2.38321C6.55847 2.42601 6.60439 2.50557 6.60439 2.59094Z",
    stroke: "#5555FF",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5429 2.591V10.7679C12.5429 10.948 12.3514 11.0642 12.1894 10.9854C10.154 9.99638 8.8939 9.91311 6.97217 10.9544C6.80836 11.0431 6.60498 10.9272 6.60498 10.7409V2.58672C6.60498 2.50367 6.64887 2.42559 6.71973 2.38226C9.06524 0.947936 10.3329 1.17242 12.4231 2.38328C12.4969 2.42607 12.5429 2.50563 12.5429 2.591Z",
    stroke: "#5555FF",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.80abd0b42094e6c0a9e766bf8ee814f7.svg";
export { ForwardRef as ReactComponent };